import { defineMessage } from '@lingui/macro';

// Night palettes shipped in tokens.css. `swatch` is only for the picker; name
// and description are Lingui descriptors, rendered with `i18n._()`.
export const DEFAULT_PALETTE = 'midnight';

const PALETTES = [
  {
    id: 'midnight',
    name: defineMessage({ message: 'Midnight KDS' }),
    description: defineMessage({
      message: 'Cool KDS neutrals; charcoal and midnight become the surfaces.',
    }),
    swatch: ['#16171D', '#1E1F26', '#2F3039', '#6EBEFF', '#E8E9EF'],
  },
  {
    id: 'graphite',
    name: defineMessage({ message: 'Graphite' }),
    description: defineMessage({
      message: 'Material dark: pure grey, elevated app bar, pastel accents.',
    }),
    swatch: ['#121212', '#1E1E1E', '#2C2C2C', '#8AB4F8', '#DEDEDE'],
  },
  {
    id: 'deep-ocean',
    name: defineMessage({ message: 'Deep Ocean' }),
    description: defineMessage({
      message: 'Navy tinted by the brand blue; premium dashboard look.',
    }),
    swatch: ['#0B1220', '#111A2B', '#1F2C47', '#5B9DFF', '#E4EAF5'],
  },
  {
    id: 'obsidian',
    name: defineMessage({ message: 'Obsidian' }),
    description: defineMessage({
      message: 'Near-black, highest contrast, saturated accent.',
    }),
    swatch: ['#0A0A0C', '#131316', '#232329', '#4D8FF7', '#F4F4F7'],
  },
  {
    id: 'slate-dusk',
    name: defineMessage({ message: 'Slate Dusk' }),
    description: defineMessage({
      message: 'Softer, lower-contrast slate for long monitoring sessions.',
    }),
    swatch: ['#1B1C21', '#23242A', '#32333B', '#7FA7E8', '#D6D7DD'],
  },
];

export const PALETTE_IDS = PALETTES.map((p) => p.id);

// Browser chrome colour (<meta name="theme-color">) per theme = --if-nav-bg.
export const NAV_COLORS = {
  light: '#2F3039',
  midnight: '#101116',
  graphite: '#272727',
  'deep-ocean': '#070D18',
  obsidian: '#050506',
  'slate-dusk': '#14151A',
};

export default PALETTES;
